import * as React from 'react';
import {
  Typography, ListItem, ListItemAvatar, Avatar, ListItemText, Divider,
} from '@mui/material';
import { selectAuthUser } from 'base/auth/selectors';
import { WhiteBgCard } from 'components';
import { useSelector } from 'react-redux';

const Badges = () => {
  const authUser = useSelector(selectAuthUser);
  const { badges } = authUser.attributes;

  const earnedBadges = React.useMemo(
    () => badges.filter((badge) => !badge.fromAdmin),
    [badges],
  );
  const badgesFromAdmin = React.useMemo(
    () => badges.filter((badge) => badge.fromAdmin),
    [badges],
  );

  return (
    <WhiteBgCard sx={{ mb: 3 }}>
      <div className="col d-none d-md-block">
        <Typography className="lh-1" variant="h6" sx={{ mb: 3 }}>
          Badges and accreditations
        </Typography>
      </div>
      <div className="col d-block d-md-none">
        <Typography className="lh-1" variant="h5" sx={{ mb: 3 }}>
          Badges and accreditations
        </Typography>
      </div>

      {earnedBadges && earnedBadges.length > 0 ? earnedBadges.map((data) => (
        <ListItem sx={{ p: 0, mb: 2 }} key={`${data.badgeTitle}-${Math.random()}`}>
          <ListItemAvatar sx={{ minWidth: 'auto', mr: 1 }}>
            <Avatar
              alt=""
              src={data.badgeImgUrl}
            />
          </ListItemAvatar>
          <ListItemText
            sx={{ my: 0 }}
            primary={<Typography variant="body2" sx={{}}>{data.badgeTitle}</Typography>}
            secondary={data.badgeDescription}
          />
        </ListItem>
      )) : (
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          There are no earned badges yet
        </Typography>
      )}

      <Divider sx={{ mt: 3, mb: 2 }} />

      <Typography variant="body2" sx={{ color: 'text.secondary', mb: 2 }}>
        {badgesFromAdmin && badgesFromAdmin.length > 0 ? 'Badges received from admin' : 'No badges received from admin'}
      </Typography>

      {badgesFromAdmin?.map((data, index) => (
        <ListItem
          sx={{ p: 0, mb: index === (badgesFromAdmin.length - 1) ? 0 : 2 }}
          key={`${data.badgeTitle}-${Math.random()}`}
        >
          <ListItemAvatar sx={{ minWidth: 'auto', mr: 1 }}>
            <Avatar
              alt=""
              src={data.badgeImgUrl}
            />
          </ListItemAvatar>
          <ListItemText
            sx={{ my: 0 }}
            primary={<Typography variant="body2" sx={{}}>{data.badgeTitle}</Typography>}
            secondary={data.badgeDescription}
          />
        </ListItem>
      ))}

    </WhiteBgCard>
  );
};

export default Badges;
